module.exports = __webpack_public_path__ + "img/483d5bd.svg";